import * as React from 'react';
import { Amount } from '@liveauctioneers/caterwaul-components/lib/types/Amount';
import { BodySecondary, H5 } from '@liveauctioneers/hammer-ui-core/text';
import { FormattedNumber } from '@liveauctioneers/hammer-ui-core/intl';
import { Info } from '@liveauctioneers/hammer-ui-core/icons';
import styled from 'styled-components';
import Tooltip from '@liveauctioneers/caterwaul-components/lib/Tooltip/Tooltip';

type Props = {
    amount: Amount;
    bold?: boolean;
    infoText?: React.ReactNode;
    label: React.ReactNode;
};

const InvoiceSummaryListRow = ({ amount, bold, infoText, label }: Props) => {
    const Text = bold ? H5 : BodySecondary;
    return (
        <StyledInvoiceSummaryListRow>
            <StyledLabelAndInfo>
                <Text>{label}</Text>
                {Boolean(infoText) && (
                    <Tooltip
                        placement="top"
                        trigger={
                            <Info
                                className="inline-flex"
                                color="primary"
                                size="xs"
                            />
                        }
                    >
                        {infoText}
                    </Tooltip>
                )}
            </StyledLabelAndInfo>
            <Text>
                <FormattedNumber
                    currency={amount.currency || 'USD'}
                    key="invoice-summary-list-row-amount"
                    maximumFractionDigits={2}
                    minimumFractionDigits={2}
                    style="currency"
                    value={amount.amount || 0}
                />
            </Text>
        </StyledInvoiceSummaryListRow>
    );
};

export default InvoiceSummaryListRow;

const StyledInvoiceSummaryListRow = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
`;

const StyledLabelAndInfo = styled.div`
    display: flex;
    align-items: center;
`;
